import { render, staticRenderFns } from "./OrmBatchingAvailableQuotes.vue?vue&type=template&id=008505e5"
import script from "./OrmBatchingAvailableQuotes.vue?vue&type=script&lang=js"
export * from "./OrmBatchingAvailableQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('008505e5')) {
      api.createRecord('008505e5', component.options)
    } else {
      api.reload('008505e5', component.options)
    }
    module.hot.accept("./OrmBatchingAvailableQuotes.vue?vue&type=template&id=008505e5", function () {
      api.rerender('008505e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormbatching/OrmBatchingAvailableQuotes.vue"
export default component.exports